import StoredLayout from '../../layouts/StoredLayout'
import TimelineWidgets from './TimelineWidgets'
export default StoredLayout(TimelineWidgets)
